<template>
  <div class="fldy-container">
    <el-row class="tcf-row">
      <el-col  class="card">
        <div class="card-body">
          <el-form :inline="true" size="small" :model="searchForm" @submit.native.prevent>
            <el-form-item label="操作时间">
              <el-date-picker
                v-model="searchForm.opertime"
                format="yyyy年MM月dd日"
                value-format="yyyy-MM-dd HH:mm:ss"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="搜索关键字">
              <el-input v-model="searchForm.search" placeholder="关键字搜索" @keyup.enter.native="Search"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button icon="el-icon-search" @click="Search">搜索</el-button>
            </el-form-item>
            <el-form-item>
              <el-button icon="el-icon-printer" :loading="exportLoading" plain @click="exportExcel">导出Excel</el-button>
            </el-form-item>
          </el-form>
          <div class="card-content" >
            <el-row>
              <el-col :span="24" v-loading="loading">
                <el-table
                  :data="tableData"
                  stripe
                  :row-style="{cursor: 'pointer'}"
                  style="width: 100%">
                  <el-table-column
                    label="月份"
                    width="60"
                    align="center"
                    fixed
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span>{{scope.row.month}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="周次"
                    width="60"
                    align="center"
                    fixed
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span>{{scope.row.week}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="订单号"
                    width="120"
                    align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span>{{scope.row.ordernum}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="生产单号"
                    width="120"
                    align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span style="font-weight: 500;color:#409EFF">{{scope.row.produnum}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="时间"
                    width="120"
                    align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span>{{scope.row.time}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="发现工序"
                    width="120"
                    align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span>{{scope.row.testProcess}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="发现人"
                    width="120"
                    align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span>{{scope.row.fxrname}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="责任部门"
                    width="120"
                    align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span>{{scope.row.dept}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="不良类别"
                    width="120"
                    align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span>{{scope.row.bad}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="责任工序"
                    width="120"
                    align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span>{{scope.row.process}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="直接责任人"
                    width="100"
                    align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span>{{scope.row.dutyName}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="乐捐"
                    width="100"
                    align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span style="color:#409EFF;font-weight: 500;">{{scope.row.punish}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="返修负责人"
                    width="100"
                    align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span>{{scope.row.principalName}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="返工成本"
                    width="100"
                    align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span>{{scope.row.cost}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="计划完成时间"
                    width="120"
                    align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span>{{scope.row.planned}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="不良现象描述"
                    min-width="240"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span>{{scope.row.descc}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="处理措施"
                    width="240"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span>{{scope.row.measures}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="负责人确认时间"
                    width="170"
                    align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <el-tag size="mini" type="danger" v-if="scope.row.contime==null||scope.row.contime==''||scope.row.contime==undefined">未确认</el-tag>
                      <span v-if="scope.row.contime!==null&&scope.row.contime!==''&&scope.row.contime!==undefined">{{scope.row.contime}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    width="120"
                    fixed="right"
                    align="center"
                    label="操作">
                    <template slot-scope="scope">
                      <el-button size="mini"  :loading="deleteLoading" @click="deleteRow(scope.row)"><i class="el-icon-delete"></i> 删除</el-button>
                    </template>
                  </el-table-column>
                </el-table>
                <el-pagination
                  v-if="total>0"
                  background
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :current-page="currentPage"
                  :page-sizes="[20, 50, 100]"
                  :page-size="pageSize"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="total">
                </el-pagination>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { getUser } from '@/utils/auth'
import { exportReworkOrderRecordList, getReworkOrderAll, deleteReworkOrder } from '@/api/erp'

export default {
  name: 'fgjl',
  computed: {
    user: getUser
  },
  data() {
    return {
      deleteLoading: false,
      exportLoading: false,
      loading: false,
      tableData: [],
      currentPage: 1,
      pageSize: 20,
      total: 0,
      searchForm: {
        opertime: [],
        search: null
      }
    }
  },
  created() {
    this.getData()
  },
  methods: {
    deleteRow(row) {
      this.$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.deleteLoading = true
        const data = {
          roid: row.roid,
          userid: this.user.dUserid,
          role: this.user.role,
          groupid: this.user.dGroupid
        }
        deleteReworkOrder(data).then(response => {
          this.getData()
          this.deleteLoading = false
        }).catch(() =>{
          this.deleteLoading = false
        })
      }).catch(() => {
        this.deleteLoading = false
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    exportExcel() {
      if (!this.exportLoading) {
        this.exportLoading = true
        let starttime = ''
        let endtime = ''
        if (this.searchForm.opertime !== null && this.searchForm.opertime !== undefined) {
          if (this.searchForm.opertime.length === 2) {
            starttime = this.searchForm.opertime[0]
            endtime = this.searchForm.opertime[1]
          }
        }
        const data = {
          content: this.searchForm.search,
          starttime: starttime,
          endtime: endtime,
          userid: this.user.dUserid,
          groupid: this.user.dGroupid,
          role: this.user.role
        }
        this.$message({
          message: '数据正在导出，请稍候'
        })
        exportReworkOrderRecordList(data).then(response => {
          this.exportLoading = false
          const _this = this
          let xhr = new XMLHttpRequest()
          xhr.open('GET', response.data.dPath, true)
          xhr.responseType = 'blob'
          xhr.onload = function() {
            if (this.status === 200) {
              let blob = this.response
              let a = document.createElement('a')
              a.download = response.data.dName + '.' + response.data.dType
              a.href = window.URL.createObjectURL(blob)
              a.target = '_blank'
              a.click()
              const h = _this.$createElement
              _this.$msgbox({
                title: '下载提示',
                message: h('div', { attrs: { style: 'letter-spacing:1px;padding-left: 15px;line-height: 22px;' }}, [
                  h('span', null, `文件已下载，如文件未下载成功，请关闭相应浏览器拦截，`),
                  h('a',
                    { attrs: {
                      href: window.URL.createObjectURL(blob),
                      target: '_blank',
                      download: `${response.data.dName}.${response.data.dType}`,
                      style: 'color: #409EFF;text-decoration:underline;'
                    }}, `点击这里`),
                  h('span', null, `重新下载。`)
                ]),
                showCancelButton: false,
                confirmButtonText: '关闭',
                beforeClose: (action, instance, done) => {
                  done()
                }
              }).then(action => {
              })
            }
          }
          xhr.send()
        }).catch(() => {
          this.exportLoading = false
        })
      }
    },
    getData() {
      this.loading = true
      let starttime = ''
      let endtime = ''
      if (this.searchForm.opertime !== null && this.searchForm.opertime !== undefined) {
        if (this.searchForm.opertime.length === 2) {
          starttime = this.searchForm.opertime[0]
          endtime = this.searchForm.opertime[1]
        }
      }
      const data = {
        content: this.searchForm.search,
        starttime: starttime,
        endtime: endtime,
        page: this.currentPage,
        limit: this.pageSize,
        userid: this.user.dUserid,
        groupid: this.user.dGroupid,
        role: this.user.role
      }
      getReworkOrderAll(data).then(response => {
        this.loading = false
        this.tableData = response.data
        this.total = response.total
      }).catch(() => {
        this.loading = false
      })
    },
    Search() {
      this.currentPage = 1
      this.getData()
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getData()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getData()
    }
  }
}
</script>

<style lang="scss" scoped>
  .fldy-container {
    .tcf-row{
      .card{
        .card-body{
          .card-title{
            .search-mode{
              width: 300px;
              position: relative;
              float: right;
              margin-top: -10px;
              .search-input{
                background-color: #F2F6FC;
                border:0;
                height: 40px;
                line-height: 40px;
                border-radius: 4px;
                color: #606266;
                padding: 0 40px 0 15px;
                -webkit-appearance: none;
                font-size: 12px;
                width: 100%;
                -webkit-box-sizing: border-box;
                box-sizing: border-box;
                outline: 0;
                &::-webkit-input-placeholder {
                  color: #C0C4CC;
                }
                &::-ms-input-placeholder {
                  color: #C0C4CC;
                }
              }
              .search-btn{
                position: absolute;
                right: 0;
                height: 40px;
                width: 40px;
                line-height: 40px;
                top: 0;
                border: 0;
                background: transparent;
                text-align: center;
                padding: 0;
              }
            }
          }
          .card-content{
            .group-filter{
              width: 100%;
              padding: 0 30px 0 0 ;
              margin: 0 ;
              position: relative;
              li{
                width: 100%;
                list-style: none;
                position: relative;
                padding-left: 20px;
                padding-top: 15px;
                padding-bottom: 15px;
                cursor: pointer;
                border-radius: 2px;
                text-overflow: ellipsis;
                overflow: hidden;
                white-space: nowrap;
                &.active{
                  background: #f5f7fa;
                  color:#409EFF;
                }
                &:hover{
                  color:#409EFF;
                }
              }
            }
            .client-sex{
              width: 16px!important;
              height: 16px!important;
              vertical-align: -4px!important;
            }
            .el-table::before{
              height: 0!important;
            }
            .el-pagination{
              margin-top: 20px;
            }
          }
        }
      }
    }
  }
</style>
